import AdminNews from './AdminNews';
export default AdminNews;
